exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.languages div[data-v-079210fd]{\r\n  min-width: 50px;\r\n  margin: 3px 5px;\r\n  display: flex;\n}\n.languages div span[data-v-079210fd]{\r\n  height: 20px;\r\n  width: 20px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  margin: 0 3px;\n}\n.languages div span img[data-v-079210fd]{\r\n  max-height: 20px;\r\n  max-width: 20px;\n}\n.languages .changeable[data-v-079210fd]:hover{\r\n  color: #008acc;\r\n  cursor: pointer;\n}\nhr[data-v-079210fd] {\r\n  margin: 0 5px;\n}\r\n", ""]);

// exports
